import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelectMultiple } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';


const ClassInput: InputWithSource = ({ input }) => (
    <GenericSelectMultiple
        label={input.name}
        input={input}
        message={ValidationMessages.requiredInput(input.name)}
    />
);

ClassInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ClassInput);
